<script setup lang="ts">
import { computed } from "vue";
import type { IListItemProps } from "./VListItem.types";

const props = withDefaults(defineProps<IListItemProps>(), {
  value: undefined,
  subValue: undefined,
  divider: true,
  theme: "primary",
});

const rootClass = computed(() => [
  "pl-list-item",
  `pl-list-item_${props.theme}`,
  {
    "pl-list-item_divider": props.divider,
  },
]);
</script>

<template>
  <div :class="rootClass">
    <div v-if="$slots.left" class="pl-list-item-left">
      <slot name="left" />
    </div>

    <div class="pl-list-item-content">
      <div v-if="$slots.default || value" class="pl-list-item-content-left">
        <div v-if="$slots.default" class="pl-list-item__title">
          <slot />
        </div>

        <div v-if="$slots.subtitle" class="pl-list-item__subtitle">
          <slot name="subtitle" />
        </div>
      </div>

      <div v-if="value || subValue" class="pl-list-item-content-right">
        <div v-if="value" class="pl-list-item__value">
          {{ value }}
        </div>

        <div v-if="subValue" class="pl-list-item__sub-value">
          {{ subValue }}
        </div>
      </div>
    </div>

    <div v-if="$slots.right" class="pl-list-item-right">
      <slot name="right" />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.pl-list-item {
  display: flex;
  padding: 2px 0;

  &__title {
    font: var(--pl-font-body-large-accent);
  }

  &__subtitle {
    margin-top: var(--pl-unit-x1);
  }

  &_divider {
    box-shadow: inset 0 -1px 0 var(--pl-divider-primary);
  }

  &_secondary {
    .pl-list-item__subtitle {
      color: var(--pl-text-secondary);
    }
  }
}

.pl-list-item-right,
.pl-list-item-left {
  flex-shrink: 0;
  display: flex;
  height: 40px;
}

.pl-list-item-left {
  margin-right: var(--pl-unit-x4);
}

.pl-list-item-right {
  margin-left: var(--pl-unit-x2);
}

.pl-list-item-content {
  flex-grow: 1;
  font: var(--pl-font-body-small-regular);
  display: flex;
  padding: var(--pl-unit-x2) 0;
}

.pl-list-item-content-left {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.pl-list-item-content-right {
  display: flex;
  flex-direction: column;
  margin-left: var(--pl-unit-x3);
  align-items: flex-end;
  white-space: nowrap;
}
</style>
